import { isResource } from '@medplum/core'
import type { List } from '@medplum/fhirtypes'
import { compact } from 'lodash-es'
import { invariant } from '#src/invariant.ts'
import { ExtendedList } from '#src/models/list.ts'
import { isReferenceString } from '#src/references.ts'
import { isOfType, parseReferenceString } from '#src/utils.ts'

export class RecentSelections extends ExtendedList {
  static isInstance(value: unknown): value is List {
    return isResource(value) && isOfType(value, 'List')
  }

  add(selectedValue: string): void {
    if (isReferenceString(selectedValue)) {
      const reference = parseReferenceString(selectedValue)
      invariant(reference, 'Invalid reference')
      this.resource.entry = [
        {
          item: reference,
        },
        ...(this.resource.entry ?? []).filter(
          (e) => e.item.reference !== reference.reference
        ),
      ]
    } else {
      this.resource.entry = [
        {
          item: {
            display: selectedValue,
          },
        },
        ...(this.resource.entry ?? []).filter(
          (e) => e.item.display !== selectedValue
        ),
      ]
    }
  }

  get values(): string[] {
    return compact(
      this.resource.entry?.map((e) => e.item.reference ?? e.item.display) ?? []
    )
  }
}
